import React from "react";

import { cn } from "@/utils/helpers/classnames";

interface LabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  className?: string;
}

const Label: React.FC<LabelProps> = ({ children, className = "", ...props }) => {
  const sizeClasses = "text-sm 2xl:text-base";

  return (
    <label
      {...props}
      className={cn(`font-inter ${sizeClasses} font-medium leading-none text-text-primary ${className}`)}
    >
      {children}
    </label>
  );
};

export default Label;
